export default from './CustomNumberInput';



// WEBPACK FOOTER //
// ./src/sharedComponents/PercentInputField/components/CustomNumberInput/index.js